import { useEffect, useRef } from 'react';
import { Row, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Devices from '../../components/blocks/devices';
import Filters from '../../components/blocks/filters';
import ScansDaytime from '../../components/blocks/scansDaytime';
import ScansLocation from '../../components/blocks/scansLocation';
import Title from '../../components/blocks/title/meQrTitle';
import TotalScans from '../../components/blocks/totalScans';
import TotalUsersChart from '../../components/blocks/totalUsersChart';
import UniqueUsers from '../../components/blocks/uniqueUsers';
import UniqueUsersChart from '../../components/blocks/uniqueUsersChart';
import { setPreloader } from '../../redux/slices/preloader';
import DownloadCsv from '../../components/blocks/downloadCsv';
import useUrlParams from '../../hooks/useUrlParams';
import { setFilters } from '../../redux/slices/filters';
import GlobalWidgets from '../../components/globalWidgets';
import { setPdfContentRef } from '../../hooks/usePdfDownload';
import withSuspense from '../../utils/hoc/withSuspense';

const CouponStatisticsLazy = withSuspense(() =>
  import('../../components/blocks/couponStatistics')
);

const MeQrPage = () => {
  const { dataLoad, isStatisticCollecting, statisticPath, filters, folderId } =
    useSelector((state) => ({
      dataLoad: state.preloader.dataLoad,
      isStatisticCollecting: state.meQrData.isStatisticCollecting,
      statisticPath: state.meQrData.statisticPath,
      filters: state.filters,
      folderId: state.meQrData.folderId
    }));

  const dispatch = useDispatch();
  const { id } = useUrlParams();
  const contentRef = useRef(null);

  useEffect(() => {
    setPdfContentRef(contentRef);
    return () => setPdfContentRef(null);
  }, []);

  useEffect(() => {
    dispatch(setPreloader(Object.values(dataLoad).some((item) => item)));
  }, [dispatch, dataLoad]);

  useEffect(() => {
    if (id) {
      dispatch(
        setFilters({
          ...filters,
          qrIds: [Number(id)],
          mode: 'period',
          isFitersActive: true
        })
      );
    }
    // eslint-disable-next-line
  }, [id]);

  if (id && filters.qrIds.length === 0) {
    return null;
  }

  return (
    <>
      <GlobalWidgets />
      {(statisticPath || isStatisticCollecting) && <DownloadCsv />}
      <Container ref={contentRef}>
        <Row className="g-4 mb-5">
          <div data-pdf-exclude>
            <Title />
            <Filters />
          </div>
          <TotalScans />
          <UniqueUsers />
          {filters.qrIds.length === 1 && folderId === null && (
            <CouponStatisticsLazy
              key={`${filters.qrIds[0]}-${new Date(filters.periodStart).getTime()}-${new Date(filters.periodEnd).getTime()}`}
            />
          )}
          <TotalUsersChart />
          <UniqueUsersChart />
          <ScansDaytime />
          <ScansLocation />
          <Devices />
        </Row>
      </Container>
    </>
  );
};

export default MeQrPage;
